import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PatientService } from '../patient.service';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PatientDialogDataModel } from '../patient-dialog-data.model';
import { PatientDataModel } from '../../../models/patient/patient-data.model';
import { AddressDataModel } from '../../../models/person/address-data.model';
import { ContactCommsDataModel } from '../../../models/person/contact-comms-data.model';
import {
    DuplicatePatientFoundDialogComponent
} from '../../../dialog/duplicate-patient-found-dialog/duplicate-patient-found-dialog.component';
import { StaticDataService } from '../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { UiService } from '../../../services/ui.service';
import { DialogService } from '../../../services/dialog.service';
import { DoctorsService } from '../../../services/doctors.service';
import { ContactDataModel } from '../../../models/person/contact-data.model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { CommLocationEnum } from '../../../models/enum/comm-location.enum';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { InsuranceService } from '../../insurance/insurance.service';
import { AutofillService } from '../../../services/autofill.service';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from 'src/app/main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { NoteTypeEnum } from 'src/app/models/enum/note-type.enum';
import { NoteCategoryEnum } from 'src/app/models/enum/note-category.enum';
import { NotesService } from 'src/app/services/notes.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
    selector: 'app-patient-edit',
    templateUrl: './patient-edit.component.html',
    styleUrls: ['./patient-edit.component.scss'],
})

export class PatientEditComponent implements OnInit, OnDestroy {
    isLoading = true;
    webIdLoading: boolean = false;
    webIdEmailSending: boolean = false;
    showInsuranceCard: boolean = true;
    isSaving: boolean = false;
    isReady: boolean = false;
    title: string = 'Edit Patient';
    hasPatientInformation: boolean = true;
    newContact: any;
    mode: string = 'EditPatient';
    type: string = '';
    error: string;
    errorTimeout: any;
    //initWebId: boolean = false;
    saveSoloContact: boolean = false;
    needsNameBeforeGeneratingWebID: boolean = false;
    foundSimilarMessage: string = null;
    editPatientFormGroup: UntypedFormGroup;
    errorMessage: string = '';
    tabIndex: number = 0;
    difficultyLevels: EnumValidValueItemModel[];
    enumRelationToPatient: EnumValidValueItemModel[];
    enumSalutation: EnumValidValueItemModel[];
    enumNameSuffix: EnumValidValueItemModel[];
    dataPatient: PatientDataModel;
    dataDoctor: DoctorDataModel;

    mainHomeMobileCommunication: ContactCommsDataModel;
    mainHomePhoneCommunication: ContactCommsDataModel;
    mainHomeEmailCommunication: ContactCommsDataModel;
    mainHomeAddress: AddressDataModel;

    genderEnums: EnumValidValueItemModel[];
    stateListEnums: EnumValidValueItemModel[] = [];

    datemask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    /** ***************************************************************************************************************************************
     * Leaving as any datatype because an interface would not suffice and
     * they are different data types that all hold a common needed data type via property 'dataContact' (ContactDataModel).
     ****************************************************************************************************************************************/
    contacts: any[];
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    selectedNavItem: string = '';
    // Refers to if this is a doctor or patient contact
    patientContacts: ContactDataModel[];
    // Refers to if new Patient is coming from Referral Management
    isReferralPatient: boolean = false;

    private ldata: any;
    private boolOKPressed: boolean = false;
    private patCode: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PatientDialogDataModel,
        public globals: Globals,
        public dialogRef: MatDialogRef<PatientEditComponent>,
        private dialog: MatDialog,
        private readonly patientService: PatientService,
        private snackBar: MatSnackBar,
        private readonly messagingService: MessagingService,
        private readonly staticDataService: StaticDataService,
        public uiService: UiService,
        private readonly dialogService: DialogService,
        private readonly doctorService: DoctorsService,
        private readonly insuranceService: InsuranceService,
        private readonly autofillService: AutofillService,
        private readonly notesService: NotesService,
        private readonly localStorageService: LocalStorageService
    ) {
        this.mode = this.data.mode;
        this.selectedNavItem = 'personal-information';
        if (this.data.itemName) {
            this.selectedNavItem = this.data.itemName;
        } 
        else if (this.mode === 'EditContact') {
                this.selectedNavItem = 'addresses';
        }
        
    }

    onNavClick(itemName: string) {
        this.selectedNavItem = itemName;
        if (this.selectedNavItem === 'personal-information') {
            this.getMainHomeInformation();
        }
    }

    onDeleteClick() {
        switch (this.selectedNavItem) {
            case 'personal-information':
                this.onDeletePatientPressed();
                break;
        }
    }

    getTooltip() {
        switch (this.selectedNavItem) {
            case 'personal-information':
                return 'Delete Patient';
        }
    }

    isNavItemSelected(itemName: string) {
        return itemName === this.selectedNavItem;
    }

    get firstNameControl() {
        return this.editPatientFormGroup.get('firstName');
    }

    get lastNameControl() {
        return this.editPatientFormGroup.get('lastName');
    }

    get dobControl() {
        return this.editPatientFormGroup.get('dob');
    }

    onDifficultyLevelChange(event) {
        this.dataPatient.enumPatientDifficultyLevelID = event.value;
    }

    ngOnInit() {
        this.editPatientFormGroup = new UntypedFormGroup({
            firstName: new UntypedFormControl('', [Validators.required]),
            lastName: new UntypedFormControl('', [Validators.required]),
            dob: new UntypedFormControl('', [Validators.required]),

        });

        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setEnums();
                }
            });
        } else {
            this.setEnums();
        }

        switch (this.data.entityType) {
            case PatientDialogDataModel.TYPE_PATIENT:
                this.initPatient();
                break;
            case PatientDialogDataModel.TYPE_DOCTOR:
                this.data.TheContact = this.data.entity.dataContact;
                this.dataDoctor = this.data.entity as DoctorDataModel;
                this.contacts = this.dataDoctor.dataDoctorContacts;
                this.setInputValues();
                break;
            case PatientDialogDataModel.TYPE_ORGANIZATION:
                this.data.entity = this.data.TheContact;
                this.isLoading = false;
                this.isReady = true;
                this.type = PatientDialogDataModel.TYPE_ORGANIZATION;
                break;
        }

        this.saveSoloContact = this.data.saveSoloContact;

        // if (this.data.initWebId) {
        //     this.initWebId = this.data.initWebId;
        // }

        if (this.data?.title) {
            this.title = this.data.title;
        }

        switch (this.mode) {
            case PatientDialogDataModel.MODE_NEW_PATIENT:
                this.needsNameBeforeGeneratingWebID = true;

                this.dataPatient = new PatientDataModel();
                if (this.data.isReferralPatient === true) {
                    this.isReferralPatient = true;
                    const BirthDate = this.getDate(this.data.ThePatient.BirthDate);
                    this.dataPatient.dataContact.FirstName = this.data.ThePatient.dataContact.FirstName;
                    this.dataPatient.dataContact.LastName = this.data.ThePatient.dataContact.LastName;
                    this.dataPatient.dataContact.BirthDate = BirthDate;
                    this.dataPatient.BirthDate = BirthDate;
                    this.mainHomeMobileCommunication = new ContactCommsDataModel();
                    this.mainHomeMobileCommunication.isPreferred = true;
                    this.mainHomeMobileCommunication.enumCommMethodID = CommMethodEnum.Mobile;
                    this.mainHomeMobileCommunication.enumCommLocationID = CommLocationEnum.HOME;
                    const Phone = this.data.ThePatient.dataContact.dataContactComms.find(p => p.enumCommMethodID === CommMethodEnum.Mobile && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()); // this.dataPatient.dataContact.dataContactComms.find(x => x.enumCommMethodID=== CommMethodEnum.Phone).Address;
                    if (Phone !== undefined) {
                        this.mainHomeMobileCommunication.Address = Phone.Address;
                    }

                    this.mainHomeEmailCommunication = new ContactCommsDataModel();
                    this.mainHomeEmailCommunication.isPreferred = true;
                    this.mainHomeEmailCommunication.enumCommMethodID = CommMethodEnum.Email;
                    this.mainHomeEmailCommunication.enumCommLocationID = CommLocationEnum.HOME;
                    const email = this.data.ThePatient.dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email && x?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
                    if (email !== undefined) {
                        this.mainHomeEmailCommunication.Address = email.Address;
                    }

                    this.dataPatient.dataContact.dataContactComms.push(this.mainHomeMobileCommunication);
                    this.dataPatient.dataContact.dataContactComms.push(this.mainHomeEmailCommunication);
                    this.dataPatient.dataPatientDoctors.push(this.data.ThePatient.dataPatientDoctors[0]);
                }


                this.dataPatient.PatientNO = 0;
                this.dataPatient.LOCID = parseInt(this.globals.LOCID);
                this.showInsuranceCard = false;
                break;
            case PatientDialogDataModel.MODE_EDIT_CONTACT:
                // A contact is being passed into the component
                // enable contact mode
                if (this.data.entityType === PatientDialogDataModel.TYPE_DOCTOR) {
                    this.doctorService.getDoctorContacts(this.data.entity.DoctorId).subscribe((res) => {
                        this.data.TheContact.dataContactContacts = res;
                    });
                }
                break;
            case PatientDialogDataModel.MODE_NEW_CONTACT:
                this.showInsuranceCard = false;
                this.createNewContact(); // create it for the new patient
                break;
            default:

                break;
        }
    }


    initPatient() {
        if (this.mode === PatientDialogDataModel.MODE_EDIT_PATIENT) {
            this.patientService.getPatient(this.data.entityId).subscribe((res) => {
                this.dataPatient = res.ThePatient;
                this.data.entity = this.dataPatient;
                this.globals.ThePatient = res.ThePatient;
                this.contacts = this.dataPatient.dataPatientContacts;
                this.globals.currentPatientId = res.ThePatient.PatientId;
                this.getMainHomeInformation();
                this.setInputValues();
            });
        } 
        else {
            this.dataPatient = new PatientDataModel();
            this.dataPatient.LOCID = parseInt(this.globals.LOCID);
            this.dataPatient.dataContact = new ContactDataModel();
            this.dataPatient.dataContact.dataContactComms = [];
            this.dataPatient.dataContact.dataAddresses = [];
            this.dataPatient.dataContact.dataContactContacts = [];
            this.dataPatient.dataPatientInsurances = [];
            this.dataPatient.dataPatientContacts = [];
            this.dataPatient.dataPatientDoctors = [];
            // this.data.entity = this.data.entity;
            if (this.mode === 'NewPatient') {
                this.dataPatient.enumPatientDifficultyLevelID = '00000107-1000-0000-0000-000000000001';
                this.data.entity = this.dataPatient;
            }
            this.contacts = this.data.contacts;
            this.setInputValues();
        }
    }

    getMainHomeInformation() {
        let mobileComms = this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Mobile && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        mobileComms = mobileComms.sort((a, b) => {
            const da = new Date(a.xauditModifiedOn).getTime();
            const db = new Date(b.xauditModifiedOn).getTime();
            return db - da;
        });
        this.mainHomeMobileCommunication = mobileComms[0];

        let homeComms = this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Phone && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        homeComms = homeComms.sort((a, b) => {
            const da = new Date(a.xauditModifiedOn).getTime();
            const db = new Date(b.xauditModifiedOn).getTime();
            return db - da;
        });
        this.mainHomePhoneCommunication = homeComms[0];

        let emailComms = this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Email && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        emailComms = emailComms.sort((a, b) => {
            const da = new Date(a.xauditModifiedOn).getTime();
            const db = new Date(b.xauditModifiedOn).getTime();
            return db - da;
        });
        this.mainHomeEmailCommunication = emailComms[0];

        let mainAddress = this.dataPatient.dataContact.dataAddresses.filter(p => p.enumAddressCategoryID === '00000008-1000-0000-0000-000000000001');
        mainAddress = mainAddress.sort((a, b) => {
            const da = new Date(a.xauditModifiedOn).getTime();
            const db = new Date(b.xauditModifiedOn).getTime();
            return db - da;
        });
        if (mainAddress.length > 0) {
            const idx = this.dataPatient.dataContact.dataAddresses.findIndex(p => p.AddressId === mainAddress[0].AddressId);
            if (idx > -1) {
                this.mainHomeAddress = this.dataPatient.dataContact.dataAddresses[idx];
            }
        }

    }

    setEnums() {
        this.difficultyLevels = this.staticDataService.getValidValueItemsByValidValueName('enumPatientDifficultyLevel');
        this.enumRelationToPatient = this.staticDataService.getValidValueItemsByValidValueName('enumInsuranceRelation');
        this.stateListEnums = this.staticDataService.getValidValueItemsByValidValueName('enumStateProvince');

        if (this.dataPatient) {
            this.isReady = true;
        }
    }

    setInputValues() {
        if (!this.data.entity) {
            return;
        }

        /* this.firstNameControl.setValue(this.data.entity.dataContact.FirstName);
this.lastNameControl.setValue(this.data.entity.dataContact.LastName);
this.dobControl.setValue(this.data.entity.dataContact.BirthDate);*/
        this.isReady = true;
        this.isLoading = false;
    }

    startCheckForWEBAndPassword() {
        let usernameFlag = false;
        let passwordFlag = false;

        if (this.dataPatient.WebID) {
            usernameFlag = true;
        }

        //if (this.dataPatient.WebPassword) {
        passwordFlag = true;
        //}

        this.checkForUsernameAndPasswordForPatient(this.dataPatient.PatientId, usernameFlag, passwordFlag);
    }

    checkForUsernameAndPasswordForPatient(patientId: string, hasUsername: boolean, hasPassword: boolean) {

        const promises = [
            this.generateUsernameForPatient(patientId),
            this.generatePasswordForPatient(patientId),
        ];

        this.webIdLoading = true;
        Promise.all(promises).then((results: any[]) => {

            if (!hasUsername) {
                this.dataPatient.WebID = results[0];
                // this.globals.ThePatient.WebID = results[0];
            }

            if (!hasPassword) {
                //this.dataPatient.WebPassword = results[1];
                // this.globals.ThePatient.WebPassword = results[1];
            }

            this.webIdLoading = true;

        }, err => {
            this.webIdLoading = false;
            console.log(err);
        });
    }

    onDeletePatientPressed() {
        this.dialogService.openConfirmDialog('Are you sure you want to delete this patient?').subscribe((result) => {
            if (result) {
                this.markPatientAsDeleted();
            }
        });
    }

    markPatientAsDeleted() {
        this.isSaving = true;
        this.patientService.markPatientAsDeleted(this.globals.ThePatient.PatientId)
            .subscribe(response => {
                this.isSaving = false;
                if (response == "OK") {
                    this.snackBar.open('Patient deleted', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top'
                    });
                    // Clear current patient data
                    this.patientService.clearCurrentPatient();
                    this.globals.ThePatient = null;
                    this.globals.currentPatientFullName = null;
                    this.globals.currentPatientCaseId = null;
                    this.globals.currentPatientId = null;
                    localStorage.removeItem('currentPatientId');
                    localStorage.removeItem('currentPatientFullName');
                    localStorage.removeItem('currentPatientCaseId');
                    
                    // Refresh recent patients list
                    const userId = this.localStorageService.currentUserData.authdata.userid;
                    this.patientService.getRecentPatients(userId).subscribe(() => {
                        // Force refresh of the recent patients list in service
                        this.patientService.recentPatients = this.patientService.recentPatients.filter(
                            patient => patient.PatientId !== this.data.entityId
                        );
                    });
                    
                    // Close the dialog and notify parent components
                    this.dialogRef.close({refresh: true, patientDeleted: true});
                    
                    // Send message to refresh relevant components
                    this.messagingService.sendComponentMessage('PATIENT_DELETED', {
                        patientId: this.data.entityId
                    });
                }
                else {
                    this.dialogService.openConfirmDialog('This patient can not be deleted !<br/>' + response, false, false, 'Not Deleted').subscribe((result) => {
                        if (result) {
                            // Do nothing on confirmation
                        }
                    });
                }
            }, err => {
                console.log('err', err);
                this.isSaving = false;
                this.snackBar.open('Error deleting patient', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top'
                });
            });
    }

    sendPatientUsernameAndPassword() {
        if (this.dataPatient.dataContact.dataContactComms) {
            const emailComms = this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Email && p.Address !== null && p.Address !== '');
            const phoneComms = this.dataPatient.dataContact.dataContactComms.filter(p => (p.enumCommMethodID === CommMethodEnum.Phone || p.enumCommMethodID === CommMethodEnum.Mobile) && p.Address !== null && p.Address !== '');

            if (emailComms.length === 0 && phoneComms.length === 0) {
                this.dialogService.openConfirmDialog('A phone number or email address is required to use this feature.', false, false, 'Please add communication details');
            }
        } else {
            // Show popup
            this.dialogService.openConfirmDialog('A phone number or email address is required to use this feature.', false, false, 'Please add communication details');
        }
        const host = location.origin;
        // make sure the patient has the username and password

        this.webIdEmailSending = true;
        this.patCode = null;
        this.patientService.sendPatientUsernameAndPasswordToPatient(this.dataPatient.PatientId, host, this.dataPatient.WebID)
            .subscribe((response: any) => {
                this.webIdEmailSending = false;

                if (response.Success) {
                    this.snackBar.open('Credentials sent', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top'
                    });
                    this.patCode = response.Token;
                }
                else {
                    this.snackBar.open('Error sending credentials: ' + response.Message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top'
                    });
                }

            }, err => {
                console.log(err);
                this.snackBar.open('Failed to send email', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top'
                });
                this.webIdEmailSending = false;
            });
    }

    sendUsernameAndPassword() {
        const promise = new Promise((resolve, reject) => {
            const host = location.origin;
            this.patientService.sendPatientUsernameAndPasswordToPatient(this.dataPatient.PatientId, host, this.dataPatient.WebID)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    generateUsernameForPatient(patientId: string) {
        const promise = new Promise((resolve, reject) => {
            this.patientService.generateUsernameForPatient(patientId)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    generatePasswordForPatient(patientId: string) {
        const promise = new Promise((resolve, reject) => {
            this.patientService.generatePasswordForPatient(patientId)
                .subscribe(resolve, reject);
        });
        return promise;
    }

    createNewContact() {

        this.isSaving = true;
        this.patientService.getNewContact(this.globals.ThePatient.PatientId)
            .subscribe(response => {
                if (response) {
                    response.xauditDeleted = false;

                    this.newContact = response;
                } else {
                    // error
                    this.addErrorMessage('Something went wrong when creating a new contact');
                }
                this.isSaving = false;
            }, err => {
                this.isSaving = false;
                this.addErrorMessage('Something went wrong when creating a new contact');
            });
    }

    createNewPatient() {
        this.isSaving = true;
        this.patientService.getNewPatient()
            .subscribe(response => {
                this.isSaving = false;
                if (response) {
                    response.xauditDeleted = false;
                    response.dataContact.xauditDeleted = false;
                    this.dataPatient = response;
                    // this.startCheckForWEBAndPassword();
                } else {
                    // error
                    this.addErrorMessage('Something went wrong when creating a new patient');
                }
            }, err => {
                this.isSaving = false;
                this.addErrorMessage('Something went wrong when creating a new patient');
                console.log(err);
            });
    }


    private cleanPatientData(): void {
        const contact = this.dataPatient?.dataContact;
      
        if (contact) {
          contact.FirstName = contact.FirstName?.trim() || '';
          contact.MidName = contact.MidName?.trim() || '';
          contact.LastName = contact.LastName?.trim() || '';
        }
      }      
      
    onSave() {

        // Call the method to clean the patient data
        this.cleanPatientData();


        console.log('onSave', this.mode);
        this.isSaving = true;
        switch (this.mode) {
            case 'EditPatient':
            case 'NewPatient':
                this.onCloseOKDialog();
                break;
            case 'NewContact':

                break;
            case 'EditContact':
                {
                this.boolOKPressed = true;
                this.isSaving = true;
                const cont = this.data.TheContact;
                if (this.data.entityType === PatientDialogDataModel.TYPE_PATIENT) {
                    this.patientService.saveDataContact(this.globals.ThePatient.PatientId, cont)
                        .subscribe(response => {
                            this.isSaving = false;
                            this.dialogRef.close(true);
                        }, err => {
                            this.isSaving = false;
                            this.addErrorMessage('Something went wrong when saving, please try again');
                        });
                } else if (this.type === PatientDialogDataModel.TYPE_ORGANIZATION) {
                    this.data.TheContact = this.data.entity;
                } else {
                    // backend expects a different interface
                    const contactsToSave: ContactDataModel[] = [];
                    if (this.contacts) {
                        this.contacts.forEach(con => {
                            contactsToSave.push(con.dataContact);
                        });
                    }

                    this.doctorService.saveDoctorContacts(this.data.entity.DoctorId, contactsToSave).subscribe((res) => {

                        this.patientService.saveContactStandalone(this.data.TheContact).subscribe((res1) => {
                            this.dialogRef.close(true);
                            this.isSaving = false;
                        });
                    });
                }
                break;
            }
        }
    }

    async onCloseOKDialog() {
        this.errorMessage = '';

        if (this.mode === 'EditContact') {
            this.dialogRef.close();
            return;
        }

        this.boolOKPressed = true;
        this.isSaving = true;
        this.callSavePatient(); 
    }

    callSavePatient() {
        const isNew = !this.dataPatient.PatientId;

        this.patientService.savePatient(this.dataPatient).subscribe(async response => {

            if (!response.isPatientAlreadyExisted) {

                const optedOut = this.dataPatient.dataContact.dataContactComms.find(c => c.isOptOutOverwritten);
                if (optedOut) {
                    const storedUser = JSON.parse(localStorage.getItem('storedUser'));
                    const mod = new TdoNoteSaveModel();
                    mod.text = `Patient Opted out via TDOxComs or Patient Portal of receiving comms on ${optedOut.Address}. PMS overwrite by User: ${storedUser.fullname}.`

                    mod.patientId = this.globals.currentPatientId;

                    const assoc = new TdoNoteAssociatedObject();
                    assoc.objectId = this.globals.currentPatientId;
                    assoc.parentObjectName = 'dataPatient';
                    mod.associatedObjects = [];
                    mod.associatedObjects.push(assoc);

                    mod.categoryEnumIds = [NoteCategoryEnum.OptOutOverwriteComms];
                    mod.typeEnumIds = [NoteTypeEnum.Administartive];
                    this.notesService.saveNote(mod).subscribe((res) => {
                        this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
                    });

                }
                this.dataPatient = response.patient;
                if (response.isNewPatient) {
                    await this.sendUsernameAndPassword();
                }

                this.data.patientId = this.dataPatient.PatientId;
                this.data.ThePatient = this.dataPatient;
                this.data.entity = this.dataPatient;
                this.globals.ThePatient = JSON.parse(JSON.stringify(this.dataPatient));
                this.globals.currentPatientId = this.data.ThePatient.PatientId;
                const firstName = this.data.ThePatient.dataContact.FirstName || '';
                const midName = this.data.ThePatient.dataContact.MidName || '';
                const lastName = this.data.ThePatient.dataContact.LastName || '';
                this.globals.currentPatientFullName = `${firstName} ${midName} ${lastName}`;
                this.contacts = this.dataPatient.dataPatientContacts;
                if (this.mode !== 'EditPatient') {
                    if (this.isReferralPatient) { // change Patient without redirecting case view - then closed dialog
                        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
                            PatientID: this.data.ThePatient.PatientId,
                            Process: MessagingConstants.DO_NOT_LOAD_CASE_VIEW,
                            clearCurrentQuery: false,
                        });
                        this.insuranceService.setPatientInsuranceToDefault(this.dataPatient.PatientId).subscribe((res) => { });
                        this.dialogRef.close(this.data);
                    } else {
                        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
                            PatientID: this.data.ThePatient.PatientId,
                            clearCurrentQuery: false,
                        });
                    }
                }

            } else {
                // Notify already exists
                /// ///////////////////////////////////////////////////////////////////////////////
                const dm = new PatientDialogDataModel();
                dm.ThePatient = response.patient;
                const config = new MatDialogConfig();
                config.panelClass = 'dialog';
                config.data = dm;
                const dialogRef = this.dialog.open(DuplicatePatientFoundDialogComponent, config);
                dialogRef.afterClosed().subscribe(
                    result => {
                        if (result) {
                            this.dataPatient = result;
                            this.dialogRef.close(this.data);
                        }
                    },
                    err => {
                    }
                );
                this.isSaving = false;
                return;
            }

            this.isSaving = false;

            if (this.mode === 'NewPatient' && isNew) {
                this.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
                this.insuranceService.setPatientInsuranceToDefault(this.dataPatient.PatientId).subscribe((res) => {
                });
                return;
            }
            this.dialogRef.close(this.data);

            if (this.mode !== 'EditPatient') {
                this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
            }
        }, err => {
            this.isSaving = false;
            let msg: string = err.error.ExceptionMessage;

            if (msg == "Repo Case Form not configured for location.") {
                msg += "<br/><br/>" +
                    "Please update SETTINGS/LOCATIONS INFORMATION<br/>" +
                    "by specifying FORMS REPOSITORY (patients consent forms)";
            }

            this.dialogService.openConfirmDialog(msg, false, false, 'NOT Saved').subscribe((result) => {
                if (result) { /* empty */ }
            });

            this.addErrorMessage('Something went wrong when saving, please try again: ' + err.error.ExceptionMessage);
            console.log('Patient creation error: ', err);
        });
    }
    cantSendCredentials() {
        //const commMethodEmailId: string = '00000009-1000-0000-0000-000000000004';
        const dataContactComms = this.dataPatient.dataContact.dataContactComms;
        const emailComm = dataContactComms.find(comm => comm.enumCommMethodID === CommMethodEnum.Email);

        return !emailComm && this.dataPatient?.WebID;
    }

    onSaveSoloContact() {
        this.boolOKPressed = true;
        this.isSaving = true;
        this.patientService.saveDataContact(this.data.patientId, this.data.TheContact)
            .subscribe(response => {
                this.isSaving = false;
                this.dialogRef.close(true);
            }, err => {
                this.isSaving = false;
                this.addErrorMessage('Something went wrong when saving, please try again');
            });
    }

    onSaveNewContact() {
        this.boolOKPressed = true;
        this.isSaving = true;
        this.newContact.xauditDeleted = false;
        this.newContact.dataContact.xauditDeleted = false;

        this.patientService.saveContact(this.newContact)
            .subscribe(response => {
                this.isSaving = false;
                this.dialogRef.close(this.newContact);
            }, err => {
                this.isSaving = false;
                this.addErrorMessage('Something went wrong when saving, please try again');
            });
    }

    onCloseCancelDialog() {
        this.dialogRef.close(false);
    }

    addErrorMessage(message) {
        this.error = message;
        if (this.errorTimeout) {
            clearTimeout(this.errorTimeout);
        }

        this.errorTimeout = setTimeout(_ => {
            this.error = null;
            this.errorTimeout = null;
        }, 7000);
    }

    ngOnDestroy() {
        if (!this.boolOKPressed) {
            this.dialogRef.close(this.ldata);
        }
    }

    getPatientContacts() {
        if (this.dataPatient.dataPatientContacts) {
            return this.dataPatient.dataPatientContacts.map(p => p.dataContact);
        } else {
            return null;
        }
    }

    CheckIfSaveEnabled() {
        return (!this.firstNameControl.value || this.firstNameControl.value.length === 0) ||
            (!this.lastNameControl.value || this.lastNameControl.value.length === 0) ||
            (!this.dobControl.value || this.dobControl.value.length === 0) &&
            this.mode === 'NewPatient' || this.mode === 'EditPatient';
    }

    CheckIfSaveDisabled() {
        if (this.mode === 'NewPatient' || this.mode === 'EditPatient') {

            return (!this.dataPatient.dataContact.FirstName || this.dataPatient.dataContact.FirstName.length === 0) ||
                (!this.dataPatient.dataContact.LastName || this.dataPatient.dataContact.LastName.length === 0) &&
                (this.mode === 'NewPatient' || this.mode === 'EditPatient');
        } else {
            return false;
        }
    }

    onMiddleNameChange($event: string) {
        console.log('test');
    }

    getDate(d: any) {
        return new Date(d);
    }


    getDateString(d: any) {
        let zd = "";
        if (d) {
            zd = new Date(d).toLocaleDateString('en-US', { // you can use undefined as first argument
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            });
        }


        return zd;
    }

    getMainMobileHomeNumber() {
        if (!this.mainHomeMobileCommunication) {
            this.mainHomeMobileCommunication = new ContactCommsDataModel();
            this.mainHomeMobileCommunication.enumCommLocationID = CommLocationEnum.HOME.toLowerCase();
            this.mainHomeMobileCommunication.enumCommMethodID = CommMethodEnum.Mobile;
            this.mainHomeMobileCommunication.LOCID = parseInt(this.globals.LOCID);
            this.mainHomeMobileCommunication.Address = '';
            this.mainHomeMobileCommunication.ContactId = this.dataPatient.ContactId;
        }
        if (!this.dataPatient.dataContact.dataContactComms) {
            this.dataPatient.dataContact.dataContactComms = [];
        }
        if (this.mainHomeMobileCommunication.Address !== '' && this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Mobile && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()).length === 0) {

            if (this.dataPatient.dataContact.dataContactComms.length === 1 && this.dataPatient.dataContact.dataContactComms[0].enumCommMethodID === null) {
                this.setFirstComm(this.mainHomeMobileCommunication);
            } else {
                this.dataPatient.dataContact.dataContactComms.push(this.mainHomeMobileCommunication);
            }
        }

        return this.mainHomeMobileCommunication.Address;
    }

    getMainHomePhoneNumber() {
        if (!this.mainHomePhoneCommunication) {
            this.mainHomePhoneCommunication = new ContactCommsDataModel();
            this.mainHomePhoneCommunication.enumCommLocationID = CommLocationEnum.HOME.toLowerCase();
            this.mainHomePhoneCommunication.enumCommMethodID = CommMethodEnum.Phone;
            this.mainHomePhoneCommunication.LOCID = parseInt(this.globals.LOCID);
            this.mainHomePhoneCommunication.Address = '';
            this.mainHomePhoneCommunication.ContactId = this.dataPatient.ContactId;
        }
        if (!this.dataPatient.dataContact.dataContactComms) {
            this.dataPatient.dataContact.dataContactComms = [];
        }
        if (this.mainHomePhoneCommunication.Address !== '' && this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Phone && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()).length === 0) {
            if (this.dataPatient.dataContact.dataContactComms.length === 1 && this.dataPatient.dataContact.dataContactComms[0].enumCommMethodID === null) {
                this.setFirstComm(this.mainHomePhoneCommunication);
            } else {
                this.dataPatient.dataContact.dataContactComms.push(this.mainHomePhoneCommunication);
            }

        }

        return this.mainHomePhoneCommunication.Address;
    }


    writeMobileNumber(e: string) {
        this.mainHomeMobileCommunication.Address = e
        let z = this.dataPatient.dataContact.dataContactComms.filter(f => f.enumCommMethodID == CommMethodEnum.Mobile && f.enumCommLocationID.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        if(z.length > 0) 
            z[0].Address = e;
    }
    writePhoneNumber(e: string) {
        this.mainHomePhoneCommunication.Address = e;
        let z = this.dataPatient.dataContact.dataContactComms.filter(f => f.enumCommMethodID == CommMethodEnum.Phone && f.enumCommLocationID.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        if(z.length > 0) 
            z[0].Address = e;
    }
    writeMainEmail(e: any) {

        this.mainHomeEmailCommunication.Address = e;
        let z = this.dataPatient.dataContact.dataContactComms.filter(f => f.enumCommMethodID == CommMethodEnum.Email && f.enumCommLocationID.toLowerCase() === CommLocationEnum.HOME.toLowerCase());
        if(z.length > 0) 
            z[0].Address = e;
    }

    getMainEmail() {
        if (!this.mainHomeEmailCommunication) {
            this.mainHomeEmailCommunication = new ContactCommsDataModel();
            this.mainHomeEmailCommunication.enumCommLocationID = CommLocationEnum.HOME.toLowerCase();
            this.mainHomeEmailCommunication.enumCommMethodID = CommMethodEnum.Email;
            this.mainHomeEmailCommunication.LOCID = parseInt(this.globals.LOCID);
            this.mainHomeEmailCommunication.Address = '';
            this.mainHomeEmailCommunication.ContactId = this.dataPatient.ContactId;
        }
        if (!this.dataPatient.dataContact.dataContactComms) {
            this.dataPatient.dataContact.dataContactComms = [];
        }
        if (this.mainHomeEmailCommunication.Address !== '' && this.dataPatient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Email && p?.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()).length === 0) {

            if (this.dataPatient.dataContact.dataContactComms.length === 1 && this.dataPatient.dataContact.dataContactComms[0].enumCommMethodID === null) {
                this.setFirstComm(this.mainHomeEmailCommunication);
            } else {
                this.dataPatient.dataContact.dataContactComms.push(this.mainHomeEmailCommunication);
            }
        }

        return this.mainHomeEmailCommunication.Address;
    }

    setFirstComm(mainCommunication: ContactCommsDataModel) {
        this.dataPatient.dataContact.dataContactComms[0].enumCommLocationID = mainCommunication.enumCommLocationID;
        this.dataPatient.dataContact.dataContactComms[0].enumCommMethodID = mainCommunication.enumCommMethodID;
        this.dataPatient.dataContact.dataContactComms[0].Address = mainCommunication.Address;
        this.dataPatient.dataContact.dataContactComms[0].isPreferred = mainCommunication.isPreferred;
    }

    checkMainAddress() {
        if (!this.mainHomeAddress) {
            this.mainHomeAddress = new AddressDataModel();
            this.mainHomeAddress.enumAddressCategoryID = '00000008-1000-0000-0000-000000000001';
            this.mainHomeAddress.LOCID = this.globals.LOCID;
            this.dataPatient.dataContact.dataAddresses.push(this.mainHomeAddress);
        }

        return this.mainHomeAddress;
    }

    getMainAddress1() {
        return this.checkMainAddress().Address1;
    }

    getMainAddress2() {
        return this.checkMainAddress().Address2;
    }

    getSuburb() {
        return this.checkMainAddress().Suburb;
    }

    getCity() {
        return this.checkMainAddress().City;
    }

    onStateChange(event: EnumValidValueItemModel) {
        const model = this.stateListEnums.find(p => p.ValidValueItemId.toLowerCase() === event.ValidValueItemId.toLowerCase());
        if (model) {
            this.mainHomeAddress.State = model.ItemSValue;
            this.mainHomeAddress.enumStateProvinceID = model.ValidValueItemId;
        }
    }

    getPostCode() {
        return this.checkMainAddress().PostCode;
    }

    onInputDOBFinished(event: any) {
        console.log('DOB event: ', event);
        this.dataPatient.dataContact.BirthDate = event;
        this.dataPatient.BirthDate = event;
        console.log('DOB event datacontact: ', this.dataPatient.dataContact.BirthDate);
        console.log('DOB event profile: ', this.dataPatient.BirthDate);
    }
    onInputAddressFinished(event: any) {
        const selectedAddress = this.checkMainAddress();

        this.autofillService.getAddressDataFromInput(`${selectedAddress.Address1} ${selectedAddress.City} ${selectedAddress.PostCode} `).subscribe((response) => {
            selectedAddress.PostCode = response.zipcode ?? selectedAddress.PostCode;
            selectedAddress.City = response.city ?? selectedAddress.City;
            const stateEnu = this.stateListEnums.find(p => p.ItemDisplayValue.toLowerCase() === response.state?.toLowerCase());
            if (stateEnu) {
                selectedAddress.State = stateEnu.ItemSValue;
                selectedAddress.enumStateProvinceID = stateEnu.ValidValueItemId;
            }
        });
    }
    changeIsMobilePreferred(event: MatCheckboxChange) {
        if (event.checked && this.mainHomeMobileCommunication.isOptOut) {
            this.dialogService.openConfirmDialog('This patient opted out of this type of communication.<br/> Would you like to overwrite patient choice?').subscribe((result) => {

                if (result) {
                    this.mainHomeMobileCommunication.isOptOut = false;
                    this.mainHomeMobileCommunication.isPreferred = true;
                    this.mainHomeMobileCommunication.isOptOutOverwritten = true;
                }
                else {
                    event.source.checked = false;
                    this.mainHomeMobileCommunication.isPreferred = false;
                }
            });
        }
        else
            this.mainHomeMobileCommunication.isPreferred = event.checked;

    }


}
